import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../type';

export const questionSelector = (state: RootState) => state.question;

export const isQuestionSelector = createSelector(questionSelector, (state) => state);
